class BottomBar extends HTMLElement {
  constructor() {
    super();
    // console.log ("entering bootom bar", )
    this.scrollDown = 'scroll-down';
    this.scrollUp = 'scroll-up';
    this.lastScroll = 0;
    this.lastFlip = 0;
    this.offSet = 50;
    this.alwaysShowFooter = false;

    this.bottom_bar = this.querySelector( '#bottom_bar' );
    window.addEventListener( 'scroll', this.update.bind( this ) );

    const currentUri = window.location.pathname;

    if ( currentUri.includes( 'pages/restaurants' ) ) {
      this.alwaysShowFooter = true;
      this.bottom_bar.classList.add( this.scrollDown );
    }
    // console.log ("currentUri = ", currentUri)
    // console.log ("this.alwaysShowFooter = ", this.alwaysShowFooter)
    this.contentForLayout = document.querySelector( 'main.content-for-layout' );
    this.restaurantHeader = document.querySelector( '.restaurant-header' );
  }

  update() {
    if (this.alwaysShowFooter) {
      return;
    }

    const currentScroll = window.scrollY;
    // console.log( " scroll to ", currentScroll );
    if ( currentScroll <= 0 ) {
      this.bottom_bar.classList.remove( this.scrollUp );
      return;
    }
    if ( currentScroll > this.lastScroll &&
      Math.abs( currentScroll - this.lastFlip ) > this.offSet &&
      !this.bottom_bar.classList.contains( this.scrollDown ) ) {
      // down
      this.bottom_bar.classList.remove( this.scrollUp );
      this.bottom_bar.classList.add( this.scrollDown );
      this.lastFlip = currentScroll;
    }
    else if ( currentScroll < ( this.lastScroll - this.offSet ) &&
      Math.abs( currentScroll - this.lastFlip )  > this.offSet &&
      this.bottom_bar.classList.contains( this.scrollDown ) ) {
      // up
      this.bottom_bar.classList.remove( this.scrollDown );
      this.bottom_bar.classList.add( this.scrollUp );
      this.lastFlip = currentScroll;
    }
    this.lastScroll = currentScroll;
  }

  connectedCallback () {
    // console.log( "entering bootom bar connectedCallback, this.restaurantHeader = ", this.restaurantHeader );

    if (this.restaurantHeader) {
      // console.log( "It has a restaurant header connectedCallback", );
      // this.contentForLayout.style.marginBottom = "100px";
    }
  }

}

customElements.define( 'bottom-bar', BottomBar );